import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Article, LoaderError } from '../../../../model';
import { PyStateUtils } from '../../../../state';
import { loaderErrorDetailsSelector } from '../../../../state/utils/loader';
import { CatalogState, StateWithCatalog } from '../../../store/catalog-state';
import { getCatalogState } from '../../../store/selectors/feature.selector';

export const getArticlesState: MemoizedSelector<StateWithCatalog, StateUtils.EntityLoaderState<Article>> = createSelector(
  getCatalogState,
  (state: CatalogState) => state && state.articles
);

export const getArticleLoaderState = (code: string): MemoizedSelector<StateWithCatalog, StateUtils.LoaderState<Article>> => {
  return createSelector(
    getArticlesState,
    (details) => PyStateUtils.entityLoaderStateSelector(details, code) || PyStateUtils.initialLoaderState
  );
};

export const getArticleLoading = (code: string): MemoizedSelector<StateWithCatalog, boolean> => {
  return createSelector(getArticleLoaderState(code), (articleState) => StateUtils.loaderLoadingSelector(articleState));
};

export const getArticleSuccess = (code: string): MemoizedSelector<StateWithCatalog, boolean> => {
  return createSelector(getArticleLoaderState(code), (articleState) => StateUtils.loaderSuccessSelector(articleState));
};

export const getArticleFailure = (code: string): MemoizedSelector<StateWithCatalog, LoaderError> => {
  return createSelector(getArticleLoaderState(code), (articleState) => loaderErrorDetailsSelector(articleState));
};

export const getArticle = (code: string): MemoizedSelector<StateWithCatalog, Article> => {
  return createSelector(getArticleLoaderState(code), (articleState) => StateUtils.loaderValueSelector(articleState));
};
